import styled from 'styled-components'

import { Table as AntTable, Button as AntButton } from 'src/components/Ant'

export const Table = styled(AntTable)`
  border-radius: 4px;
  margin: 0 16px 24px 16px;
`

export const Button = styled(AntButton)`
  margin-left: 0.5rem;
`

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div > div {
    margin-left: 1rem;
  }
`
